import axios from 'axios';
import { ApiErrorResponse } from '@/types/error-type';

function rejectedSignature(error: unknown, depth = 0): boolean {
  if (!error || typeof error !== 'object' || depth > 4) return false;
  const detail = error as { code?: unknown; message?: unknown; cause?: unknown };
  return (
    detail.code === 4001 ||
    detail.code === 'ACTION_REJECTED' ||
    (typeof detail.message === 'string' &&
      /user rejected|user denied|signature.*rejected/i.test(detail.message)) ||
    rejectedSignature(detail.cause, depth + 1)
  );
}

export function getAuthError(error: unknown, fallback: string): Error {
  // Axios interceptors turn business errors into ApiErrorResponse without an Axios response.
  // Preserve its code and fields before classifying transport failures.
  if (error instanceof ApiErrorResponse) return error;
  if (rejectedSignature(error)) {
    return new Error('You canceled the signature request. Try again when you’re ready.');
  }
  if (axios.isAxiosError(error) && !error.response) {
    return new Error('Connection interrupted. Check your connection and try again.');
  }
  return error instanceof Error ? error : new Error(fallback);
}
